<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>What benefits do you offer to your employees?</h1>
    <p>
      Please check the benefits that you offer to your employees to allow us to
      configure your payroll.
    </p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
        <!-- Popular options -->
        <h2>Most Common Benefits</h2>
        <br/>
        <div
          v-for="option in popularOptions"
          :key="option.fieldName"
        >
          <label class="custom-check">
            <input
              type="checkbox"
              v-model="props.formData[option.fieldName]"
            />
            {{ option.displayName }}
            <span class="checkmark"></span>
          </label>
        </div>

        <!-- Toggle for other options -->
        <div v-if="!showAll">
          <a href="#" @click.prevent="showAll = true">View more…</a>
        </div>

        <!-- Other options -->
        <div v-if="showAll">
                  <br/>
          <h2>Other Benefits</h2>
                  <br/>
          <div
            v-for="option in otherOptions"
            :key="option.fieldName"
          >
            <label class="custom-check">
              <input
                type="checkbox"
                v-model="props.formData[option.fieldName]"
              />
              {{ option.displayName }}
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { putDataCollectionTask } from '@/services/implementationmanagement.api'

const error = ref([])
const route = useRoute()
const taskId = route.params.taskId
const showAll = ref(false)

const props = defineProps({
  formData: Object
})

const BIK_OPTIONS = [
  { displayName: "Assets Transferred", fieldName: "hasAssetsTransferred", popular: false },
  { displayName: "Payments Made on Behalf of Employee", fieldName: "hasPaymentsMadeOnBehalfOfEmployee", popular: true },
  { displayName: "Vouchers and Credit Cards", fieldName: "hasVouchersAndCreditCards", popular: false },
  { displayName: "Living Accommodation", fieldName: "hasLivingAccommodation", popular: false },
  { displayName: "Mileage Allowance and Passenger Payments", fieldName: "hasMileageAllowanceAndPassengerPayments", popular: false },
  { displayName: "Cars and Car Fuel", fieldName: "hasCarsAndCarFuel", popular: true },
  { displayName: "Vans and Van Fuel", fieldName: "hasVansAndVanFuel" , popular: true },
  { displayName: "Interest-Free and Low-Interest Loans", fieldName: "hasInterestFreeAndLowInterestLoans", popular: false },
  { displayName: "Private Medical Treatment or Insurance", fieldName: "hasPrivateMedicalTreatmentOrInsurance", popular: true },
  { displayName: "Qualifying Relocation Expenses, Payments and Benefits", fieldName: "hasQualifyingRelocationExpensesPaymentsAndBenefits", popular: false },
  { displayName: "Services Supplied", fieldName: "hasServicesSupplied", popular: false },
  { displayName: "Assets Placed at the Employee's Disposal", fieldName: "hasAssetsPlacedAtTheEmployeesDisposal", popular: false },
  { displayName: "Other Items (Class 1A)", fieldName: "hasOtherItemsClass1A", popular: false },
  { displayName: "Other Items (Non-Class 1A)", fieldName: "hasOtherItemsNonClass1A", popular: false },
  { displayName: "Other Items - Income Tax Paid for Director", fieldName: "hasOtherItemsIncomeTaxPaidForDirector", popular: false },
  { displayName: "Travelling and Subsistence Payments", fieldName: "hasTravellingAndSubsistencePayments", popular: false },
  { displayName: "Entertainment", fieldName: "hasEntertainment", popular: false },
  { displayName: "General Expenses Allowance for Business Travel", fieldName: "hasGeneralExpensesAllowanceForBusinessTravel", popular: false },
  { displayName: "Payments for Use of Home Telephone", fieldName: "hasPaymentsForUseOfHomeTelephone", popular: false },
  { displayName: "Non-Qualifying Relocation Expenses", fieldName: "hasNonQualifyingRelocationExpenses", popular: false },
  { displayName: "Other Expenses", fieldName: "hasOtherExpenses", popular: false }
]

const popularOptions = computed(() => BIK_OPTIONS.filter(o => o.popular))
const otherOptions = computed(() => BIK_OPTIONS.filter(o => !o.popular))

const validateStep = () => {
  error.value = []
  const atLeastOneChecked = BIK_OPTIONS.some(option => !!props.formData[option.fieldName])
  if (!atLeastOneChecked) {
    error.value.push('Please select at least one benefit.')
  }
  return error.value.length === 0
}

const executeStep = async () => {
  const payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "CompanyBiks",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  const response = await putDataCollectionTask(taskId, payload)
  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.'
    return false
  }
  return true
}

onMounted(() => {})

defineExpose({ validateStep, executeStep })
</script>
